import {SVGAttributes, useMemo} from 'react';

import SpriteSvg from '@web-catalog/assets/sprite.svg';

import {SvgIconName} from './type.generated';

type Props = SVGAttributes<SVGElement> & {
  svg: SvgIconName;
  size?: number | string | {width: number; height: number};
};

export const SpriteIcon = ({svg, size, ...rest}: Props) => {
  const svgProps: SVGAttributes<SVGElement> = useMemo(
    () => ({
      ...((typeof size === 'number' || typeof size === 'string') && {
        width: size,
        height: size,
        viewBox: `0 0 ${size} ${size}`,
      }),
      ...(typeof size === 'object' && {
        ...size,
        viewBox: `0 0 ${size.width} ${size.height}`,
      }),
      'aria-hidden': 'true',
    }),
    [size],
  );
  return (
    <svg {...svgProps} {...rest}>
      <use href={`${SpriteSvg.src}#${svg}`} />
    </svg>
  );
};
